// Rounds down, so 100% shows only when every counted item is done.
export const toPercent = (part: number, total: number): number => (total ? Math.floor((part / total) * 100) : 0);
